export const FaceDetectionsSearch = {
  title: "Búsqueda de Detecciones Faciales",
  subjectId: "Persona(s)",
  subjectIdPlaceholder: "Seleccionar persona(s)",
  subjectIdRequired: "Seleccionar al menos una persona.",
  subject: "Persona",
  probability: "Probabilidad",
  detection: "Detección",
  detections: "Detecciones faciales",
  noDetections: "No se encontraron detecciones.",
  showMap: "Mostrar mapa",
  hideMap: "Esconder mapa",
  expandMap: "Expandir mapa",
  contractMap: "Contraer mapa",
  hideMarks: "Esconder marcadores",
  showMarks: "Mostrar marcadores",
  startAnimation: "Iniciar animación",
  stopAnimation: "Detener animación",
  camera: "Cámara",
  hideUnavailableSensors: "Ocultar sensores no disponibles",
  fetchError: "No se pudieron cargar las detecciones. Intente de nuevo.",
  searchByImage: "Buscar por imagen",
  imageSearchTitle: "Buscar por imagen",
  uploadImageHint: "Haz clic o arrastra una imagen de un rostro",
  recognizing: "Reconociendo...",
  noPersonsFound: "No se encontraron coincidencias en la base de datos.",
  applySelection: "Aplicar",
  retry: "Reintentar",
  uploadError: "No se pudo procesar la imagen. Intente de nuevo.",
  detectingFaces: "Detectando rostros...",
  noFacesDetected: "No se detectaron rostros. Puedes recortar manualmente.",
  cropManually: "Recortar manualmente",
  selectFaceHint: "Selecciona el rostro que deseas buscar",
  searchFace: "Buscar",
  manualCropLabel: "Manual",
  backToSelection: "Volver",
  maxFacesHint: "Máx. 3 rostros",
  confirmCrop: "Confirmar recorte",
  stepSelectFace: "Seleccionar rostro",
  stepResults: "Resultados",
  changeImage: "Cambiar imagen",
  successfullyCopiedToClipboard:
    "El nombre se ha copiado al portapapeles exitosamente",
};
